import 'bootstrap/dist/css/bootstrap.css';
import './assets/styles/index.scss';
import 'font-awesome/css/font-awesome.min.css';
import 'antd/dist/reset.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Provider } from 'react-redux';
import { PersistGate } from "redux-persist/integration/react";
import axios from 'axios';

import router from './routes/index';

import store, { persistor } from './Store/index';
import fullstoryService from './services/fullstoryService';

// Configure axios globally
axios.defaults.withCredentials = false; // Default to false for external APIs, override for internal APIs
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000';

// Remove AI conversation history that older versions kept in localStorage (it contains business details).
try {
  Object.keys(localStorage)
    .filter((key) => key.startsWith('conversation_'))
    .forEach((key) => localStorage.removeItem(key));
} catch (error) {
  // Storage unavailable (private mode / blocked) — nothing to clean.
}

// Initialize Fullstory for analytics and session recording
fullstoryService.initialize().then((success) => {
  if (success) {
    console.log('Fullstory initialized successfully');
  } else {
    console.warn('Fullstory initialization failed - check configuration');
  }
});

if (process.env.NODE_ENV === 'production') {
  console.warn = () => {};
  console.log = () => {};
  console.error = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.trace = () => {};
  console.dir = () => {};
  console.group = () => {};
  console.groupEnd = () => {};
  console.time = () => {};
  console.timeEnd = () => {};
  console.timeLog = () => {};
  console.timeEnd = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable Strict Mode in development to prevent double API calls
const App = (
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    {process.env.NODE_ENV === 'production' ? (
      <React.StrictMode>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <RouterProvider router={router} />
          </PersistGate>
        </Provider>
      </React.StrictMode>
    ) : (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <RouterProvider router={router} />
        </PersistGate>
      </Provider>
    )}
  </GoogleOAuthProvider>
);

root.render(App);
